module.exports = __webpack_public_path__ + "media/images/card1-472ea4ac812dcdd0a0f32a46f5278f27.jpg";